module.exports = __webpack_public_path__ + "images/content-agg.409c45a7.webp";